module.exports = __webpack_public_path__ + "static/media/robotColor.744f78cb.svg";